// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"153":"component---src-pages-dashboard-index-js","678":"component---src-pages-index-js","774":"framework","883":"component---src-pages-404-js"}[chunkId] + "-" + {"153":"08c8b27a2bc0e462d9e3","678":"8c3c4b00dd4cdaf1a7a9","774":"eef86f0731961d552a4a","883":"7e23fa68b70fd42a105d"}[chunkId] + ".js";
};